// The shareable result card (1200×630): "P1 in 2026 Q4 Round 14" or
// "P1 in GT class", drawn in the browser so it needs no image server. The
// text sits on the left; the 3D art (car and posed driver, lib/card-3d.ts)
// on the right once it has rendered.
export type CardData = { name: string; headline: string; sub: string; color: string; livery: string; number: string }

export function drawPodiumCard(canvas: HTMLCanvasElement, data: CardData, art?: HTMLCanvasElement): void {
  const x = canvas.getContext('2d')
  if (!x) return
  const { width: w, height: h } = canvas
  x.fillStyle = '#0E0E0E'
  x.fillRect(0, 0, w, h)
  x.fillStyle = data.livery
  x.fillRect(0, 0, 24, h)
  x.fillStyle = data.color
  x.fillRect(80, 96, 160, 10)
  x.fillStyle = '#F3F3F1'
  x.font = 'italic 800 40px "Saira Condensed", "Arial Narrow", sans-serif'
  x.fillText('LAUNCHGP', 80, 72)
  x.fillStyle = data.color
  x.font = '600 34px "Saira Condensed", "Arial Narrow", sans-serif'
  x.fillText(data.sub.toUpperCase(), 80, 170)
  if (art) {
    // A soft glow in the livery behind the car, then the car and driver.
    const glow = x.createRadialGradient(w - 300, h * 0.62, 20, w - 300, h * 0.62, 420)
    glow.addColorStop(0, `${data.livery}55`)
    glow.addColorStop(1, `${data.livery}00`)
    x.fillStyle = glow
    x.fillRect(w - 720, 0, 720, h)
    x.drawImage(art, w - art.width, h - art.height)
  }
  const textWidth = art ? w * 0.5 - 80 : w - 160
  x.fillStyle = '#F3F3F1'
  x.font = 'italic 800 110px "Saira Condensed", "Arial Narrow", sans-serif'
  x.fillText(data.headline.toUpperCase(), 80, 300, textWidth)
  x.font = '800 72px "Saira Condensed", "Arial Narrow", sans-serif'
  x.fillText(`${data.name.toUpperCase()}  #${data.number}`, 80, 420, textWidth)
  x.fillStyle = '#A3A6AB'
  x.font = '400 30px "Saira", sans-serif'
  x.fillText('launchgp.io', 80, h - 64)
}
